import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_8 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_10 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_11 = { class: "d-flex flex-column align-items-start w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_UserAuthorizationPanel = _resolveComponent("UserAuthorizationPanel")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.rules,
          onSubmit: _withModifiers(_ctx.submit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Đơn vị")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "id_don_vi",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.id_don_vi,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.id_don_vi) = $event)),
                            class: "w-100",
                            placeholder: "Chọn đơn vị",
                            filterable: "",
                            disabled: _ctx.isUnitLevel
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donViOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: _ctx.donViOptionLabel(item),
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Họ và tên")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "ho_va_ten",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.ho_va_ten,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ho_va_ten) = $event)),
                            placeholder: "Nhập họ và tên",
                            name: "ho_va_ten",
                            maxlength: "30",
                            "show-word-limit": "",
                            onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Số điện thoại")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "so_dien_thoai",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.so_dien_thoai,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.so_dien_thoai) = $event)),
                            placeholder: "Nhập số điện thoại",
                            name: "so_dien_thoai",
                            maxlength: "15",
                            "show-word-limit": "",
                            onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Email")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "email",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.email,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.email) = $event)),
                            placeholder: "Nhập email",
                            name: "email",
                            onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_LabelCustom, { "is-required": _ctx.isCreating }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mật khẩu")
                        ]),
                        _: 1
                      }, 8, ["is-required"]),
                      _createVNode(_component_el_form_item, {
                        prop: "mat_khau",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.mat_khau,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.mat_khau) = $event)),
                            type: "password",
                            "show-password": "",
                            placeholder: 
                      _ctx.isCreating ? 'Nhập mật khẩu (8-32 ký tự)' : 'Nhập MK mới'
                    ,
                            name: "mat_khau",
                            maxlength: "32"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.isCreating)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_7, " Để trống nếu không đổi "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_LabelCustom, { "is-required": _ctx.isCreating }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Xác nhận mật khẩu ")
                        ]),
                        _: 1
                      }, 8, ["is-required"]),
                      _createVNode(_component_el_form_item, {
                        prop: "mat_khau_confirm",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.mat_khau_confirm,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.mat_khau_confirm) = $event)),
                            type: "password",
                            "show-password": "",
                            placeholder: 
                      _ctx.isCreating ? 'Nhập lại mật khẩu' : 'Nhập lại MK mới'
                    ,
                            name: "mat_khau_confirm",
                            maxlength: "32"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.isCreating)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_9, " Để trống nếu không đổi "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Bộ phận")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "id_bo_phan",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.id_bo_phan,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.id_bo_phan) = $event)),
                            class: "w-100",
                            placeholder: "Chọn bộ phận",
                            filterable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boPhanOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.ten_bo_phan,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Chức vụ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "id_chuc_vu",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.id_chuc_vu,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.id_chuc_vu) = $event)),
                            class: "w-100",
                            placeholder: "Chọn chức vụ",
                            filterable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chucVuOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.ten_chuc_vu,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.actorIsAdmin)
              ? (_openBlock(), _createBlock(_component_DivRow, {
                  key: 0,
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, { cols: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserAuthorizationPanel, {
                          "selected-roles": _ctx.selectedRoles,
                          "onUpdate:selectedRoles": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedRoles) = $event)),
                          "selected-permissions": _ctx.selectedPermissions,
                          "onUpdate:selectedPermissions": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedPermissions) = $event)),
                          "can-manage": _ctx.canManage,
                          saving: _ctx.savingAuth,
                          "role-options": _ctx.roleOptions,
                          "permission-groups": _ctx.permissionGroups,
                          onRolesChange: _ctx.handleAuthChange,
                          onPermissionsChange: _ctx.handleAuthChange
                        }, null, 8, ["selected-roles", "selected-permissions", "can-manage", "saving", "role-options", "permission-groups", "onRolesChange", "onPermissionsChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DivRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  cols: 12,
                  "additional-class": "d-flex justify-content-center gap-x-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.SAVE,
                      "color-type": _ctx.ButtonTypeColors.SUCCESS,
                      disabled: _ctx.isLoading || _ctx.pageLoading,
                      "is-loading": _ctx.isLoading,
                      onClick: _ctx.submit
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Lưu")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type", "disabled", "is-loading", "onClick"]),
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.REFRESH,
                      "color-type": _ctx.ButtonTypeColors.WARNING,
                      disabled: _ctx.isLoading || _ctx.pageLoading,
                      onClick: _ctx.clear
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Nhập lại")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type", "disabled", "onClick"]),
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.BACK,
                      onClick: _ctx.goBack
                    }, null, 8, ["button-type", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "onSubmit"])
      ])), [
        [_directive_loading, _ctx.pageLoading]
      ])
    ]),
    _: 1
  }))
}